import React from "react";
import underconstruction from "../../../assets/images/UnderConstruction.png"
export default function ManageClasses() {
 
  return (
    <>
      <div>
      <div>  <img alt="logo" width="20%" src={underconstruction} /></div>
      </div>
    </>
  );
}
